import { createReducer } from "@reduxjs/toolkit";
import type { UpdateState } from "@redux/state/shared-types";
import { updateRoles, resetUpdateRoles } from "./update-roles";

const initialState: UpdateState = { justUpdatedId: null, processing: "idle" };

export const updateRolesReducer = createReducer<UpdateState>(initialState, builder => {
  builder.addCase(updateRoles.fulfilled, (state, { payload }) => {
    return {
      ...state,
      justUpdatedId: payload,
      processing: "success",
    };
  });
  builder.addCase(updateRoles.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(updateRoles.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetUpdateRoles, () => {
    return initialState;
  });
});
